import React from 'react';
import { Select, MenuItem } from '@material-ui/core';

const LIST_STATUSES = ['In Picklist', 'In Leavelist', 'Pending Approval'];

const getStatusLabel = (rowData) => {
  const name = rowData?.status?.displayName;
  if (name === 'In Picklist') return `In Picklist (${rowData?.picklist?.name || ''})`;
  if (name === 'In Leavelist') return `In Leavelist (${rowData?.leavelist?.name || ''})`;
  return name || '';
};

export default function StatusSelect({ rowData, availableStatuses, onStatusChange }) {
  const currentStatus = rowData?.status;
  const isListStatus = LIST_STATUSES.includes(currentStatus?.displayName);

  // Render plain text for list-managed statuses
  if (isListStatus) {
    return <span>{getStatusLabel(rowData)}</span>;
  }

  const handleChange = (e) => {
    console.log('selected value:', e.target.value);
    console.log('availableStatuses:', availableStatuses);
    const selectedStatus = availableStatuses.find((s) => s.name === e.target.value);
    console.log('found status:', selectedStatus);
    if (selectedStatus && selectedStatus.name !== currentStatus?.name) {
      onStatusChange(rowData.id, selectedStatus);
    }
  };

  // Filter out list-managed statuses from the dropdown options
  const selectableStatuses = availableStatuses.filter(
    (s) => !LIST_STATUSES.includes(s.displayName)
  );

  return (
    <Select value={currentStatus?.name || ''} onChange={handleChange} disableUnderline displayEmpty>
      {selectableStatuses.map((status) => (
        <MenuItem key={status.name} value={status.name}>
          {status.displayName}
        </MenuItem>
      ))}
    </Select>
  );
}
